@if (layer().meta.dataType === 'Layer') {
  <button
    igoStopPropagation
    (mouseenter)="onMouseEvent($event)"
    (mouseleave)="onMouseEvent($event)"
    mat-icon-button
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="computeTooltip() | translate"
    [color]="(isPreview$ | async) ? '' : added() ? 'warn' : ''"
    (click)="onToggleClick($event)"
  >
    <mat-icon
      aria-hidden="false"
      matBadge="icon"
      [igoMatBadgeIcon]="getBadgeIcon()"
      igoMatBadgeColor="rgba(0,0,0,0.87)"
      igoMatBadgeBackgroundColor="none"
      [igoMatBadgeInverseColor]="true"
      [matBadgeHidden]="
        ((inRange$ | async) && (isVisible$ | async) === true) ||
        ((inRange$ | async) && !added()) ||
        ((inRange$ | async) && (isPreview$ | async))
      "
      [matBadgeDisabled]="(inRange$ | async) === false"
      matBadgeSize="small"
      matBadgePosition="after"
      >{{ (isPreview$ | async) ? 'add' : added() ? 'delete' : 'add' }}
    </mat-icon>
  </button>
}

@if (layer().meta.dataType === 'Feature' && saveSearchResultInLayer()) {
  <button
    [id]="!isMobile ? 'hide-save-search-result-btn' : ''"
    igoStopPropagation
    mat-icon-button
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="addFeatureToLayerTooltip$ | async | translate"
    (click)="addFeatureToLayer()"
  >
    <mat-icon
      aria-hidden="false"
      matBadge="icon"
      igoMatBadgeIcon="visibility_off"
      [igoMatBadgeInverseColor]="true"
      [matBadgeHidden]="inRange$ | async"
      [matBadgeDisabled]="true"
      matBadgeSize="small"
      matBadgePosition="after"
      >add_to_photos
    </mat-icon>
  </button>
}
